import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, Label, Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';
import { uniqueId } from 'lodash';
import Translate from '../Translate';
import equipmentVinCategoriesJson from './equipmentVindDeodingCategories.json';

const ranks = [
  { id: 0, label: 'other' },
  { id: 1, label: 'outsideEquipment' },
  { id: 2, label: 'interiorEquipment' },
  { id: 3, label: 'entertainmentEquipment' },
  { id: 4, label: 'comfortEquipment' },
  { id: 5, label: 'safetyEquipment' },
];
const VinDecodingEquipmentsModal = (props) => {
  const { isOpen, setIsOpen, equipments } = props;
  const [equipment, setEquipment] = useState(equipments || []);
  const [listOpen, setLIstOpen] = useState({});
  const handleClose = async () => {
    setIsOpen(false);
  };

  useEffect(() => {
    setEquipment(
      equipments.map((eqp) =>
        equipmentVinCategoriesJson[`${eqp.id}`]?.rank
          ? { ...eqp, rank: equipmentVinCategoriesJson[`${eqp.id}`]?.rank }
          : eqp,
      ),
    );
  }, [equipments]);
  useEffect(() => {
    setLIstOpen(
      ranks.reduce((acc, current) => {
        acc[current.label] = true;
        return acc;
      }, {}),
    );
  }, []);
  const handleOPen = (label) => {
    setLIstOpen((prev) => ({ ...prev, [label]: !listOpen[label] }));
  };

  return (
    <Modal size="xl" isOpen={isOpen} centered>
      <div className="modal-vin-decoding">
        <ModalBody className="container ">
          <div className="row justify-content-between" style={{ gap: '20px' }}>
            {ranks.map(
              (el) =>
                equipment.some((eqp) => eqp?.rank === el.id) && (
                  <div key={uniqueId(el.id)} className="col-12 col-md-5 col-sm-5">
                    <Label className="text-primary text-left h5" style={{ fontSize: isMobile ? '14px' : '18px' }}>
                      <FontAwesomeIcon
                        icon={listOpen[el.label] ? faChevronDown : faChevronRight}
                        style={{ cursor: 'pointer' }}
                        className="mr-2"
                        onClick={() => handleOPen(el.label)}
                      />
                      <Translate code={el.label} />
                    </Label>
                    <Collapse isOpen={listOpen[el.label]}>
                      <ul className="row modal-vin-decoding-collapse">
                        {equipment
                          .filter((item) => item.rank === el.id)
                          .map((eqp) => (
                            <li
                              key={uniqueId(eqp.id)}
                              className="pl-0 col-6 text-dark col-md-5 col-sm-5 text-break"
                              style={isMobile ? { fontSize: '12px' } : {}}
                            >
                              <small>{eqp.name}</small>
                            </li>
                          ))}
                      </ul>
                    </Collapse>
                  </div>
                ),
            )}
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <button type="button" className="btn btn-3" onClick={handleClose}>
            <Translate code="cancel" />
          </button>
        </ModalFooter>
      </div>
    </Modal>
  );
};
VinDecodingEquipmentsModal.propTypes = {
  equipments: PropTypes.oneOfType([PropTypes.array]).isRequired,
  setIsOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default VinDecodingEquipmentsModal;
